import React, {useRef, useState} from "react";
import QRCode from "react-qr-code";
import {CloseIcon} from "../../assets/icons";
import {BodyText, DisplayStart, FormControl, InputText} from "../../Components/StyledComponents";
import { fabric } from 'fabric';
import {useDispatch, useSelector} from "react-redux";


const QRCodeScanner = ({setToggleSubMenu}) => {
    const {canvas} = useSelector((state) => state.canvas);
    const [QRCodeVal, setQRCodeVal] = useState('https://atlasmemorials.com/editor/')
    const qrCodeRef = useRef(null);

    const closeImagesPanel = () => {
        setToggleSubMenu(false)
    }
    const handleChange = (e) => {
        setQRCodeVal(e.target.value)
    }
    const addQRCode = () => {
        const svg = document.getElementById("QRCode");
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas1 = document.createElement("canvas");
        const ctx = canvas1.getContext("2d");
        const img = new Image();
        img.onload = () => {
            canvas1.width = img.width;
            canvas1.height = img.height;
            ctx.drawImage(img, 0, 0);
        };
        img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;

        fabric.Image.fromURL(img.src, function (img) {
            canvas.add(img);
            canvas.setActiveObject(img)
            canvas.renderAll();
        });
    };

    return(
        <div className='image-properties-wrapper mt-3'>
            <div className='images-header'>
                <span className="heading-text">QR Code</span>
                <span onClick={closeImagesPanel} className='cross-icon'><CloseIcon/></span>
            </div>
            <div style={{ height: "auto", margin: "30px auto", maxWidth: 200, width: "100%" }}>
                <div ref={qrCodeRef}>
                    <QRCode
                        id="QRCode"
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={QRCodeVal}
                        viewBox={`0 0 256 256`}
                    />
                </div>
            </div>
            <FormControl>
                <BodyText>QR Code URL</BodyText>
                <DisplayStart>
                    <InputText
                        type="text"
                        placeholder="Parents Name"
                        value={QRCodeVal}
                        onChange={handleChange}
                    />
                </DisplayStart>
            </FormControl>
            <div className='add-text-btn-wrapper'>
                <div className='add-text-btn' onClick={addQRCode}>
                    <span>Add QR code</span>
                </div>
            </div>

        </div>
    )
}
export default QRCodeScanner